import { ThunkAction } from "redux-thunk";
import { SetActiveRoute } from "Store/application";
import { setActiveRoute } from "Action_creators/set_active_route";
import { Store } from "Store/index";

/**
 * Leverages the HTML history API to navigate to a different route and publishes
 * changes to the Store.
 */
export function navigate(
  route: URL,
  usePushState = true
): ThunkAction<SetActiveRoute, Store, undefined, SetActiveRoute> {
  if (usePushState === true) {
    history.pushState({ route: route.pathname }, "", route.href);
  }

  return (dispatch, getState) => {
    return dispatch(setActiveRoute(route.pathname));
  };
}
